"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const BreadcrumbsModal_vue_1 = __importDefault(require("./components/BreadcrumbsModal.vue"));
const TrialsConfigurationSamplesService_1 = __importDefault(require("../../Abstract/services/TrialsConfigurationSamplesService"));
const AssignationPayload_1 = __importDefault(require("../../Abstract/models/AssignationPayload"));
const ModalWarningAssignation_vue_1 = __importDefault(require("./ModalWarningAssignation.vue"));
const ModalConfirmAction_vue_1 = __importDefault(require("./ModalConfirmAction.vue"));
const ModalLoading_vue_1 = __importDefault(require("./ModalLoading.vue"));
let ModalSamplesList = class ModalSamplesList extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.currentMissingSamples = this.missingSamples;
        this.alreadyAssignedChecked = [];
        this.stage = 'list';
        this.samplesService = new TrialsConfigurationSamplesService_1.default(this.params);
        this.isSuccessful = false;
        this.feedback = '';
        this.samplesAvailable = this.samples.filter((s) => s.is_available);
        // action === '' -> Listado de elementos
        // action === 'mark' -> Listado de elementos
        // action === 'assign' -> Todas las disponibles
        this.samplesScoped = this.action.length > 0 && this.action === 'assign'
            ? this.samples.filter((s) => s.is_available)
            : this.samples;
        // BELOW ALL THE SAMPLE CHECKING LOGIC
        this.arrayCodesMultySelects = [];
        this.checkContainer = [];
        this.norepeat = [];
        this.isCheckedGlobal = false;
        this.codesArraySelected = [];
        this.toSearch = '';
        this.samplesFilter = [];
        this.arrMultiCopy = [];
        this.isShowingAll = false;
        this.codesSelectedsCopys = [];
        this.isCopiedCodes = false;
    }
    onMainActionClicked() {
        if (this.action === 'assign') {
            this.preValidateSamplesAssignation();
        }
        if (this.action === 'mark') {
            this.markSent();
        }
    }
    preValidateSamplesAssignation() {
        if (this.alreadyAssignedChecked.length > 0 && this.action === 'assign') {
            this.stage = 'warning';
        }
        else {
            this.action === 'assign' ? this.assignSamples() : this.markSent();
        }
    }
    async assignSamples() {
        this.stage = 'loading';
        const data = new AssignationPayload_1.default({
            location_id: this.location.id,
            treatment_id: this.currentTreatment.meta.treatmentID,
            time: this.currentTime,
            samples: this.checkContainer,
        });
        try {
            const response = await this.samplesService.assignSamples(data);
            this.isSuccessful = true;
            this.feedback = response.data.messages;
            this.updateAssignatedSamples(data);
        }
        catch (error) {
            console.log(error);
            this.isSuccessful = false;
            this.feedback = error.data.messages;
        }
        this.stage = 'assignation';
    }
    async markSent() {
        this.stage = 'loading';
        const data = new AssignationPayload_1.default({
            location_id: this.location.id,
            treatment_id: this.currentTreatment.meta.treatmentID,
            time: this.currentTime,
            samples: this.checkContainer,
        });
        try {
            const response = await this.samplesService.markSampleAsSent(data);
            this.isSuccessful = true;
            this.feedback = response.data.messages;
            this.updateSentSamples(data);
        }
        catch (error) {
            console.log(error);
            this.isSuccessful = false;
            this.feedback = error.data.messages;
        }
        this.stage = 'assignation';
    }
    updateAssignatedSamples(payload) {
        this.$emit('updateAssignatedSamples', payload);
    }
    updateSentSamples(payload) {
        this.$emit('updateSentSamples', payload);
    }
    get hasAction() {
        if (this.action.length > 0) {
            return true;
        }
        else {
            return false;
        }
    }
    get isShowingSampleList() {
        if (this.isFetching)
            return false;
        return ((this.toSearch.length > 0 && this.samplesFilter.length > 0) ||
            (this.toSearch.length < 1 && this.samplesScoped.length > 0));
    }
    updateMissingSamples() {
        this.currentMissingSamples = this.missingSamples - this.checkContainer.length;
        this.alreadyAssignedChecked = [];
        const alreadyAssigned = this.samples
            .filter((s) => !s.is_available)
            .map((sample) => sample);
        this.checkContainer.forEach((code) => {
            if (alreadyAssigned.find((as) => as.sample_code === code)) {
                this.alreadyAssignedChecked.push(alreadyAssigned.find((as) => as.sample_code === code));
            }
        });
    }
    resetSampleScoped() {
        this.samplesScoped = this.samples.filter((s) => s.is_available);
    }
    changeIsShowingAll(newValue) {
        this.isShowingAll = newValue;
        if (this.isShowingAll) {
            this.samplesScoped = this.samples;
        }
        else {
            this.resetSampleScoped();
        }
        this.onchangesearch(this.toSearch);
    }
    changeIsCheckedGlobal(newValue) {
        this.isCheckedGlobal = newValue;
    }
    dismissWarningAssignation() {
        this.stage = 'list';
    }
    isSampleSelected(code) {
        return (this.isCheckedGlobal ||
            this.arrayCodesMultySelects.includes(code) ||
            this.checkContainer.includes(code));
    }
    changeIsSampleSelected(newValue, code) {
        this.pushFn(code);
        this.pushCodesSelectedsCopys(code);
        this.updateMissingSamples();
    }
    dismissModalConfirmation() {
        this.backAction();
        this.dismissModal();
    }
    dismissModal() {
        this.$emit('dismissModalSamplesList');
    }
    backAction() {
        this.$emit('backModalSamplesList');
    }
    textUpperCase(text) {
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
    async multiCopy(sampleCode) {
        this.arrMultiCopy.push(sampleCode);
        let notRepeat = [];
        notRepeat = this.arrMultiCopy.filter((item, index) => {
            return this.arrMultiCopy.indexOf(item) === index;
        });
        notRepeat.push(' ');
        const stringCodes = notRepeat.toString();
        navigator.clipboard.writeText(stringCodes.trim());
        const t = await navigator.clipboard.readText();
    }
    async isMultiCopyFn() {
        const t = await navigator.clipboard.readText();
        if (t.split(',').length < this.arrMultiCopy.length) {
            this.arrMultiCopy = [];
        }
    }
    pushCodesSelectedsCopys(code) {
        this.codesSelectedsCopys.push(code);
    }
    copyCodesSelected() {
        this.isCopiedCodes = true;
        navigator.clipboard.writeText('');
        let notRepeat = [];
        notRepeat = this.codesSelectedsCopys.filter((item, index) => {
            return this.codesSelectedsCopys.indexOf(item) === index;
        });
        notRepeat.push(' ');
        const stringCodes = notRepeat.toString();
        navigator.clipboard.writeText(stringCodes);
        this.codesSelectedsCopys = [];
        setTimeout(() => {
            this.isCopiedCodes = false;
        }, 1500);
    }
    multipleSelect(sampleCode) {
        this.arrayCodesMultySelects = [];
        const pre = this.checkContainer[0];
        const last = sampleCode;
        const arrSamples = [];
        for (const sample of this.samplesScoped) {
            arrSamples.push(sample.sample_code);
        }
        const preIndex = arrSamples.indexOf(pre);
        const lastIndex = arrSamples.indexOf(last);
        if (lastIndex > preIndex) {
            this.arrayCodesMultySelects = arrSamples.slice(preIndex, lastIndex + 1);
            for (const code of this.arrayCodesMultySelects) {
                this.checkContainer.push(code);
            }
        }
        else {
            this.arrayCodesMultySelects = arrSamples.slice(lastIndex, preIndex + 1);
            for (const code of this.arrayCodesMultySelects) {
                this.checkContainer.push(code);
            }
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.codesArraySelected = notRepeat;
    }
    pushFn(sampleCode) {
        if (this.isCheckedGlobal) {
            this.isCheckedGlobal = false;
            this.checkContainer = [];
        }
        if (this.arrayCodesMultySelects.includes(sampleCode)) {
            this.arrayCodesMultySelects = this.checkContainer.filter((item) => item !== sampleCode);
        }
        if (this.checkContainer.includes(sampleCode)) {
            this.checkContainer = this.checkContainer.filter((item) => item !== sampleCode);
        }
        else {
            this.checkContainer.push(sampleCode);
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.norepeat = notRepeat;
        this.codesArraySelected = notRepeat;
    }
    f() {
        if (this.isCheckedGlobal) {
            this.arrayCodesMultySelects = [];
            this.checkContainer = [];
            for (const sample of this.samplesFilter) {
                this.checkContainer.push(sample.sample_code);
            }
        }
        else {
            this.checkContainer = [];
        }
        let notRepeat = [];
        notRepeat = this.checkContainer.filter((item, index) => {
            return this.checkContainer.indexOf(item) === index;
        });
        this.codesArraySelected = notRepeat;
        this.updateMissingSamples();
    }
    onchangesearch(text) {
        this.toSearch = text;
        this.samplesFilter = this.samplesScoped;
        const patt = new RegExp(text);
        if (text.includes(',') || text.includes(' ') || text.includes('|')) {
            this.samplesFilter = [];
            const arrayCodes = text.split(/[\s,|]+/);
            for (const code of arrayCodes) {
                for (const sample of this.samplesScoped) {
                    if (code
                        .toString()
                        .toLowerCase()
                        .trim()
                        .includes(sample.sample_code.toString().toLowerCase().trim() ||
                        sample.sample_code.toString().toLowerCase().trim())) {
                        this.samplesFilter.push(sample);
                    }
                }
            }
        }
        else {
            this.samplesFilter = this.samplesScoped.filter((sample) => {
                if (sample.sample_code
                    .toString()
                    .toLowerCase()
                    .trim()
                    .includes(text.toString().toLowerCase().trim()) ||
                    patt.test(sample.sample_code.toString().toLowerCase().trim())) {
                    return true;
                }
                else {
                    return false;
                }
            });
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: '' })
], ModalSamplesList.prototype, "action", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalSamplesList.prototype, "isButtonBack", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], ModalSamplesList.prototype, "isFetching", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], ModalSamplesList.prototype, "currentTime", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: null })
], ModalSamplesList.prototype, "currentTreatment", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalSamplesList.prototype, "location", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], ModalSamplesList.prototype, "samples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Number, default: -1 })
], ModalSamplesList.prototype, "missingSamples", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: {} })
], ModalSamplesList.prototype, "params", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('isCheckedGlobal')
], ModalSamplesList.prototype, "f", null);
ModalSamplesList = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            TableBmk: bmk_ui_framework_1.TableBmk,
            TableHeader: bmk_ui_framework_1.TableHeader,
            TableHeaderCell: bmk_ui_framework_1.TableHeaderCell,
            TableBodyRow: bmk_ui_framework_1.TableBodyRow,
            TableBodyCell: bmk_ui_framework_1.TableBodyCell,
            TableBody: bmk_ui_framework_1.TableBody,
            CheckBox: bmk_ui_framework_1.CheckBox,
            DateStylized: bmk_ui_framework_1.DateStylized,
            CodeSnippet: bmk_ui_framework_1.CodeSnippet,
            BreadcrumbsModal: BreadcrumbsModal_vue_1.default,
            Search: bmk_ui_framework_1.Search,
            Button: bmk_ui_framework_1.Button,
            ArrowLeftIcon: bmk_ui_framework_1.ArrowLeftIcon,
            WarningDiamondIcon: bmk_ui_framework_1.WarningDiamondIcon,
            ViewZero: bmk_ui_framework_1.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_1.MagnifyingGlassIcon,
            XRoundedIcon: bmk_ui_framework_1.XRoundedIcon,
            Loading: bmk_ui_framework_1.Loading,
            ModalWarningAssignation: ModalWarningAssignation_vue_1.default,
            ModalConfirmAction: ModalConfirmAction_vue_1.default,
            ModalLoading: ModalLoading_vue_1.default,
        },
    })
], ModalSamplesList);
exports.default = ModalSamplesList;
